import { render } from "./AddOrBackButton.vue?vue&type=template&id=055ddee8"
import script from "./AddOrBackButton.vue?vue&type=script&lang=js"
export * from "./AddOrBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__